import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState, CombinedAppState, combinedFeatureKey, featureAppKey } from './app.reducer';

const appSelector = createFeatureSelector<AppState>(featureAppKey);
const combinedAppSelector = createFeatureSelector<CombinedAppState>(combinedFeatureKey);

export const selectCxbUserSegments = createSelector(appSelector, (state) => {
  return state?.userSegments || [];
});

export const selectCxbCountries = createSelector(appSelector, (state) => {
  return state?.countries || [];
});

export const selectCxbCountryGroups = createSelector(appSelector, (state) => {
  return state?.countryGroups || [];
});

export const selectCxbPlatforms = createSelector(appSelector, (state) => {
  return state?.platforms || [];
});

export const selectIsLoading = createSelector(combinedAppSelector, (state) => {
  return Object.values(state)
    .map((featureState) => {
      if ('loading' in featureState) {
        return featureState.loading;
      }
      return false;
    })
    .some((isLoading) => isLoading);
});

export const selectCxbFeeds = createSelector(appSelector, (state) => {
  return state?.feeds || [];
});

export const selectGenres = createSelector(appSelector, (state) => state.genres);

export const selectCxbRootLevelRoles = createSelector(appSelector, (state) => {
  return state?.rootLevelRoles || null;
});

export const selectCxbTenantOptions = createSelector(appSelector, (state) => {
  return state?.tenantOptions;
});

export const selectCxbSelectedTenant = createSelector(appSelector, (state) => {
  return state?.selectedTenant;
});

export const selectCxbAdminUIDetails = createSelector(appSelector, (state) => {
  return state?.adminUIDetails;
});

export const selectTrayOptions = createSelector(appSelector, (state) => {
  return state?.trayOptions;
});

export const selectApiVersion = createSelector(appSelector, (state) => state.apiVersion);
